<div class="p-fluid p-grid">
  <div class="p-col-12">
    <p-tabView>
      <p-tabPanel header="Usuario Permissao">
        <div class="p-fluid">
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="id">Id:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <input pInputText type="text" name="id" [disabled]="true" [ngModel]="entidade.id" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Vigência:</label>
            <div class="p-col-12 p-lg-10">
              <span *ngIf="entidade.vigente" style="color: green">Vigente</span>
              <span *ngIf="!entidade.vigente" style="color: red">Encerrada</span>
              <p class="p-date-auditoria">
                Inicio em: {{ entidade.inicio | date : 'dd/MM/yyyy HH:mm:ss' }}
                <span *ngIf="!!entidade.fim"> e terminou em: {{ entidade.fim | date : 'dd/MM/yyyy HH:mm:ss' }} </span>
              </p>
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label>Origem:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <span
                *ngIf="entidade.origem === 'NATIVO'"
                style="
                  background: lightgray;
                  font-weight: bold;
                  font-size: 14px;
                  color: white;
                  border-radius: 6px;
                  display: inline;
                  padding: 2px 4px;
                "
                >Nativo</span
              >
              <span
                *ngIf="entidade.origem === 'CORPORATIVO'"
                style="
                  background: darkblue;
                  font-weight: bold;
                  font-size: 14px;
                  color: white;
                  border-radius: 6px;
                  display: inline;
                  padding: 2px 4px;
                "
                >Corporativo</span
              >
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label>Usuário:</label>
            </div>
            <div class="p-col-12 p-lg-8">
              <p-autoComplete
                placeholder="Selecione o usuário"
                [forceSelection]="true"
                appendTo="body"
                inputId="usuario"
                [suggestions]="usuarioSugestoes"
                dataKey="id"
                field="nome"
                [dropdown]="true"
                class="p-button-secondary"
                dropdownIcon="pi pi-search"
                emptyMessage="Não foi encontrado nenhum usuário"
                [(ngModel)]="entidade.usuario"
                [disabled]="entidade.id !== undefined"
                panelStyleClass="background: red;"
                (completeMethod)="onCompleteUsuario($event.query)"
                (onSelect)="onSelectUsuario()"
              >
              </p-autoComplete>
            </div>
            <div class="btn btn-group m-t-8" *ngIf="entidade.id === undefined">
              <a pButton class="p-button-sm p-m-r-2" icon="pi pi-plus" pTooltip="Novo" (click)="abrirCriaUsuarioSistemaModal()">
              </a>
              <a
                pButton
                class="p-button-sm p-m-r-2 p-button-raised p-button-info"
                icon="pi pi-arrow-down"
                (click)="abrirImportarUsuarioSistemaModal()"
                pTooltip="Importar"
              >
              </a>
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Perfil:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-dropdown
                placeholder="Selecione o perfil"
                [options]="usuarioPerfilSugestoes"
                filter="true"
                [(ngModel)]="entidade.perfil"
                [disabled]="entidade.id !== undefined || !entidade.usuario"
              >
              </p-dropdown>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="abrangencia">Abrangência:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-selectButton
                [disabled]="entidade.id !== undefined"
                [options]="abrangenciaItens"
                [(ngModel)]="entidade.abrangencia"
              ></p-selectButton>
            </div>
          </div>

          <div class="p-grid" *ngIf="entidade.abrangencia === 'NACIONAL'">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Órgão Justiça:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <input pInputText [value]="'Todos os órgãos de justiça'" disabled />
            </div>
          </div>

          <div class="p-grid" *ngIf="entidade.abrangencia === 'ORGAO_JUSTICA'">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Órgão Justiça:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-autoComplete
                placeholder="Selecione o orgão de justiça"
                [forceSelection]="true"
                appendTo="body"
                inputId="orgaoJustica"
                [suggestions]="orgaoJusticaSugestoes"
                dataKey="id"
                field="nome"
                emptyMessage="Não foi encontrado nenhum orgão de justiça"
                [(ngModel)]="entidade.orgaoJustica"
                [disabled]="entidade.id !== undefined"
                (completeMethod)="onCompleteOrgaoJustica($event.query)"
                (onDropdownClick)="onCompleteOrgaoJustica('')"
                dropdown="true"
              >
              </p-autoComplete>
            </div>
          </div>

          <div class="p-grid" *ngIf="entidade.abrangencia === 'FONTE_DADOS'">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Fonte de Dados:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-autoComplete
                placeholder="Selecione a fonte de dados"
                [forceSelection]="true"
                inputId="fonteDados"
                [suggestions]="fonteDadosSugestoes"
                dataKey="id"
                field="nome"
                emptyMessage="Não foi encontrado nenhuma fonte de dados"
                [(ngModel)]="entidade.fonteDados"
                [disabled]="entidade.id !== undefined"
                (completeMethod)="onCompleteFonteDados($event.query)"
                (onDropdownClick)="onCompleteFonteDados('')"
                dropdown="true"
              >
              </p-autoComplete>
            </div>
          </div>

          <div class="p-grid" *ngIf="entidade.abrangencia === 'ORGAO_JULGADOR_COLEGIADO'">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Órg. Julg. Colegiado:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-autoComplete
                placeholder="Selecione o órgão julgador colegiado"
                [forceSelection]="true"
                appendTo="body"
                inputId="orgaoJulgadorColegiado"
                [suggestions]="orgaoJulgadorColegiadoLocalSugestoes"
                dataKey="id"
                field="nome"
                emptyMessage="Não foi encontrado nenhum órgão julgador colegiado"
                [(ngModel)]="entidade.orgaoJulgadorColegiado"
                [disabled]="entidade.id !== undefined"
                (completeMethod)="onCompleteOrgaoJulgadorColegiado($event.query)"
              >
                <ng-template let-orgaoJulgadorColegiado pTemplate="item">
                  {{ orgaoJulgadorColegiado.fonteDados.nome }} - {{ orgaoJulgadorColegiado.nome }}
                </ng-template>
              </p-autoComplete>
            </div>
            <div class="p-col-12 p-lg-2"></div>
            <div class="p-col-12 p-lg-10">
              Tribunal:
              <span *ngIf="entidade.orgaoJulgadorColegiado !== undefined">
                {{ entidade.orgaoJulgadorColegiado?.orgaoJustica?.nome }} -
                {{ entidade.orgaoJulgadorColegiado?.orgaoJustica?.sigla }}
              </span>
            </div>
          </div>

          <div class="p-grid" *ngIf="entidade.abrangencia === 'ORGAO_JULGADOR'">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Órgão Julgador:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-autoComplete
                placeholder="Selecione o órgão julgador"
                [forceSelection]="true"
                appendTo="body"
                inputId="orgaoJulgador"
                [suggestions]="orgaoJulgadorSugestoes"
                dataKey="id"
                field="nome"
                emptyMessage="Não foi encontrado nenhum órgão julgador"
                [(ngModel)]="entidade.orgaoJulgador"
                [disabled]="entidade.id !== undefined"
                (completeMethod)="onCompleteOrgaoJulgador($event.query)"
              >
                <ng-template let-orgaoJulgador pTemplate="item">
                  {{ orgaoJulgador.orgaoJustica.sigla }} - {{ orgaoJulgador.nome }}
                </ng-template>
              </p-autoComplete>
            </div>
            <div class="p-col-12 p-lg-2"></div>
            <div class="p-col-12 p-lg-10">
              Tribunal:
              <span *ngIf="entidade.orgaoJulgador !== undefined">
                {{ entidade.orgaoJulgador?.orgaoJustica?.nome }} - {{ entidade.orgaoJulgador?.orgaoJustica?.sigla }}
              </span>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Limite Nível Sigilo:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-dropdown
                placeholder="Selecione o limite de nível de sigilo"
                [options]="nivelSigiloItens"
                filter="true"
                [(ngModel)]="entidade.limiteNivelSigilo"
                [disabled]="entidade.id !== undefined"
              >
              </p-dropdown>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
        <div class="p-fluid">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Data:</div>
            <div class="p-col-12 p-lg-9">{{ entidade.auditoriaDataInsercao | date : 'dd/MM/yyyy HH:mm:ss' }}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Usuário:</div>
            <div class="p-col-12 p-lg-9">{{ entidade.auditoriaUsuarioInsercao?.nome }}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Data:</div>
            <div class="p-col-12 p-lg-9">{{ entidade.auditoriaData | date : 'dd/MM/yyyy HH:mm:ss' }}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Usuário:</div>
            <div class="p-col-12 p-lg-9">{{ entidade.auditoriaUsuario?.nome }}</div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<p-dialog
  header="Criar novo usuário de Sistema"
  [showHeader]="true"
  [visible]="mostrarCriaUsuarioSistemaModal"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '90%', maxWidth: '800px' }"
  appendTo="body"
>
  <div style="width: 100%">
    <div *ngIf="!usuarioCriado" style="text-align: center; margin: 1em 0">
      <p>Preencha os campos abaixo para criar um novo usuário de sistema:</p>
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="login">Login:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="login" [(ngModel)]="login" (ngModelChange)="validarFormulario()" />
            <div *ngIf="loginInvalido" style="color: red; font-size: 0.9em">
              O campo login só pode conter letras minúsculas, números, “_” e “-” e não pode ser um CPF.
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="nome">Nome:</label>
          </div>
          <div class="p-col-12 p-lg-3">
            <input pInputText type="text" name="nomePrefix" [ngModel]="'Sistema'" disabled />
          </div>
          <div class="p-col-12 p-lg-7">
            <input pInputText type="text" name="nomeSufixo" [(ngModel)]="nomeSufixo" (ngModelChange)="validarFormulario()" />
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="senha">Senha:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="password" name="senha" [(ngModel)]="senha" (ngModelChange)="validarFormulario()" />
          </div>
        </div>
      </div>
      <div style="margin: 1em 0">
        <button
          (click)="fecharCriaUsuarioSistemaModal()"
          pButton
          type="button"
          label="Cancelar"
          class="p-button-danger"
          style="margin-right: 8px"
        ></button>
        <button (click)="criarUsuarioSistema()" pButton type="button" [disabled]="!validarFormulario() || carregando">
          <span *ngIf="!carregando">Salvar</span>
          <span *ngIf="carregando" class="pi pi pi-spin pi-spinner"></span>
        </button>
      </div>
      <div *ngIf="usuarioCriado">
        <div style="text-align: center; margin: 1em 0">
          <p *ngIf="usuarioCriado.existenteNoSSO">
            O usuário foi importado no CODEX, mas já estava registrado no SSO, por isso a senha prévia foi mantida.
          </p>
          <p *ngIf="!usuarioCriado.existenteNoSSO">Usuário criado com sucesso!</p>
          <a pButton class="p-button-sm p-m-r-2" pTooltip="Visualizar usuário criado">OK</a>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog
  header="Importar usuário ao Sistema"
  [showHeader]="true"
  [visible]="mostrarImportarUsuarioSistemaModal"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '90%', maxWidth: '800px' }"
  appendTo="body"
>
  <div style="width: 100%">
    <div *ngIf="!usuarioCriado" style="text-align: center; margin: 1em 0">
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="login">Usuário:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="login" id="login" [(ngModel)]="login" (ngModelChange)="validarFormulario()" />
          </div>
        </div>
      </div>
      <div style="margin: 1em 0">
        <button
          (click)="fecharImportarUsuarioSistemaModal()"
          pButton
          type="button"
          label="Cancelar"
          class="p-button-danger"
          style="margin-right: 8px"
        ></button>
        <button (click)="importarUsuarioSistema()" pButton type="button" [disabled]="!login">
          <span *ngIf="!carregando">Importar</span>
          <span *ngIf="carregando" class="pi pi pi-spin pi-spinner"></span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>
